import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function Signup() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(form.email, form.password, form.name);
      toast.success("Welcome to FuturePath!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 font-heading font-bold text-brand-blue text-xl mb-8">
          <span className="inline-flex w-8 h-8 rounded-xl bg-brand-blue text-white items-center justify-center">
            <Sparkles size={16} />
          </span>
          FuturePath
        </Link>
        <h1 className="text-3xl font-semibold text-brand-blue">Create your account</h1>
        <p className="mt-2 text-brand-muted">Save reports, track your child's journey, and revisit anytime.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="block text-sm font-medium text-brand-blue mb-1.5">Your name</label>
            <input data-testid="signup-name-input" required className="field" value={form.name} onChange={set("name")} />
          </div>
          <div>
            <label className="block text-sm font-medium text-brand-blue mb-1.5">Email</label>
            <input data-testid="signup-email-input" type="email" required className="field" value={form.email} onChange={set("email")} />
          </div>
          <div>
            <label className="block text-sm font-medium text-brand-blue mb-1.5">Password</label>
            <input data-testid="signup-password-input" type="password" required minLength={6} className="field" value={form.password} onChange={set("password")} />
            <p className="mt-1 text-xs text-brand-muted">At least 6 characters.</p>
          </div>
          <button data-testid="signup-submit-btn" disabled={loading} className="btn-primary w-full disabled:opacity-60">
            {loading ? "Creating..." : "Create account"}
          </button>
        </form>
        <p className="mt-6 text-sm text-center text-brand-muted">
          Already have an account? <Link to="/login" data-testid="signup-login-link" className="text-brand-green font-medium">Log in</Link>
        </p>
      </div>
    </div>
  );
}
